module.exports = __webpack_public_path__ + "media/packs/images/flags/UG-632da1d7b1d15ba59e4a872c5522d580.svg";